var map = {
	"./1.svg": 9266,
	"./1ocjena.svg": 8886,
	"./2.svg": 7090,
	"./2ocjena.svg": 7409,
	"./3.svg": 6889,
	"./3ocjena.svg": 3699,
	"./4.svg": 6538,
	"./4ocjena.svg": 2017,
	"./5.svg": 1793,
	"./5ocjena.svg": 2231,
	"./de.svg": 2230,
	"./en.svg": 1547,
	"./hr.svg": 827,
	"./it.svg": 700,
	"./si.svg": 6400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;